function Visual() {
  return (
    <div className="visual">
      <h2>Welcome to MyNextDPP</h2>
    </div>
  );
}

export default Visual;
